<template>
    <ScrollingDocument
        id="printJS-form"
        class="pdf-document"
        v-bind="{pages, pageCount, currentPage}"
        :enable-page-jump="true"
        @page-jump="onPageJump"
        @pages-fetch="onPagesFetch"
        @pages-reset="fitWidth"
        :class="{ 'previews-opened': this.isPreviewSidebarOpened }"
    >
        <PDFPage
            slot-scope="{page, isElementVisible, isPageFocused, isElementFocused}"
            v-bind="{scale, page, isElementVisible, isPageFocused, isElementFocused, zoom}"
            @page-rendered="onPageRendered"
            @page-errored="onPageErrored"
            @page-focus="onPageFocused"
        />
    </ScrollingDocument>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import ScrollingDocument from './ScrollingDocument';
    import PDFPage from './PDFPage';

    const PIXEL_RATIO = window.devicePixelRatio || 1;
    const VIEWPORT_RATIO = 0.98;

    export default {
        name: 'PDFDocument',
        components: {
            ScrollingDocument,
            PDFPage,
        },
        data() {
            return {
                currentPage: 1,
                zoom: 1,
                isPreviewSidebarOpened: false
            }
        },
        props: {
            pages: {
                required: true,
            },
            pageCount: {
                type: Number,
                default: 0,
            },
            scale: {
                type: Number,
                default: 1.0,
            },
            fit: {
                type: String,
            },
        },
        computed: {
            defaultViewport() {
                if (!this.pages.length)
                    return {width: 0, height:0};

                const [page] = this.pages;
                return page.getViewport({scale: 1.0});
            },
            isPortrait() {
                const {width, height} = this.defaultViewport;
                return width <= height;
            },
        },
        mounted() {
            EventBus.$on('goToPage', (page) => this.currentPage = page);
            EventBus.$on('updateZoom', (zoom) => this.zoom = zoom);
            EventBus.$on('togglePreviews', () => this.isPreviewSidebarOpened = !this.isPreviewSidebarOpened);
        },
        methods: {
            pageWidthScale() {
                const {defaultViewport, $el} = this;
                if (!defaultViewport.width)
                    return 0;
                return ($el.clientWidth * PIXEL_RATIO) * VIEWPORT_RATIO / defaultViewport.width;
            },
            pageHeightScale() {
                const {defaultViewport, $el} = this;
                if (!defaultViewport.height) return 0;

                return ($el.clientHeight * PIXEL_RATIO) * VIEWPORT_RATIO / defaultViewport.height;
            },
            fitWidth() {
                const scale = this.pageWidthScale();
                console.log('fit width scale', scale);
                this.$emit('scale-change', scale);
            },
            fitHeight() {
                const scale = this.isPortrait ? this.pageHeightScale() : this.pageWidthScale();
                console.log('fit height scale', scale);
                this.$emit('scale-change', scale);
            },
            fitAuto() {
                const scale = Math.min(this.pageWidthScale(), this.pageHeightScale());
                console.log('fit auto scale', scale);
                this.$emit('scale-change', scale);
            },
            onPageJump(scrollTop) {
                this.$el.scrollTop = scrollTop; // triggers 'scroll' event
            },
            onPagesFetch(currentPage) {
                this.$parent.$emit('pages-fetch', currentPage);
            },
            onPageFocused(pageNumber) {
                this.$parent.$emit('page-focus', pageNumber);
            },
            onPageRendered(payload) {
                this.$parent.$emit('page-rendered', payload);
            },
            onPageErrored(payload) {
                this.$parent.$emit('page-errored', payload);
            },
        },
        watch: {
            fit(fit) {
                switch (fit) {
                    case 'width':
                        this.fitWidth();
                    break;

                    case 'auto':
                        this.fitAuto();
                    break;

                    default:
                    break;
                }
            },
            pageCount: 'fitWidth',
        }
    };
</script>

<style lang="scss" scoped>
    .pdf-document {
        position: absolute;
        overflow: auto;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(64, 64, 64, 1);
        -webkit-transition: -webkit-transform .5s ease;
        transition: -webkit-transform .5s ease;
        transition: transform .5s ease;
        transition: transform .5s ease, -webkit-transform .5s ease;
        -webkit-transform: translateX(0%);
        transform: translateX(0%);
        &.previews-opened {
            transform: translateX(10%);
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/pdfViewer/PDFDocument.vue